import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=465a1ce1&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465a1ce1')) {
      api.createRecord('465a1ce1', component.options)
    } else {
      api.reload('465a1ce1', component.options)
    }
    module.hot.accept("./Logo.vue?vue&type=template&id=465a1ce1&", function () {
      api.rerender('465a1ce1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/Logo.vue"
export default component.exports